import axios from "../../../../shared/axios/axiosProxy.js";

/**
 * Name-based autocomplete with optional pagination.
 * @param {string} query
 * @param {{ page?: number, limit?: number }} [options]
 */
export const autocomplete = async (query, options = {}) => {
  const params = new URLSearchParams({ search: query });
  if (options.page != null) {
    params.set("page", String(options.page));
  }
  if (options.limit != null) {
    params.set("limit", String(options.limit));
  }
  const response = await axios.get(`/api/cegjelzo/autocomplete?${params.toString()}`);
  const data = response.data?.result ?? response.data ?? [];
  return {
    result: Array.isArray(data) ? data : [],
  };
};

/**
 * Tax-number search — returns entities mapped to autocomplete row shape by the caller.
 * @param {string} taxValue
 */
export const searchByTaxNumber = async (taxValue) => {
  const response = await axios.get(
    `/api/cegjelzo/search?value=${encodeURIComponent(taxValue)}&type=tax_number`,
  );
  const data = response.data;
  return Array.isArray(data) ? data : [];
};

/**
 * Full company details by tax number (used after selection).
 * @param {string} taxNumber
 */
export const fetchCompanyByTaxNumber = async (taxNumber) => {
  const response = await axios.get(
    `/api/cegjelzo/search?value=${encodeURIComponent(taxNumber)}&type=tax_number`,
  );
  const results = response.data;
  return Array.isArray(results) && results.length > 0 ? results[0] : null;
};
